<template>
  <div>
    <el-row style="height: 840px;">
      <search-bar @onSearch="searchResult" ref="searchBar"></search-bar>
      <el-row effect="dark" placement="right"
              v-for="item in books.slice((currentPage-1)*pagesize,currentPage*pagesize)"
              :key="item.id">
        <span>{{item.id}}</span>
        <span>{{item.date_name}}</span>
        <span>{{item.remind_content}}</span>
      </el-row>

<!--      <el-tooltip effect="dark" placement="right"-->
<!--                  v-for="item in books.slice((currentPage-1)*pagesize,currentPage*pagesize)"-->
<!--                  :key="item.id">-->
<!--        <p slot="content" style="font-size: 14px;margin-bottom: 6px;">{{item.title}}</p>-->
<!--        <p slot="content" style="font-size: 13px;margin-bottom: 6px">-->
<!--          <span>{{item.author}}</span> /-->
<!--          <span>{{item.date}}</span> /-->
<!--          <span>{{item.press}}</span>-->
<!--        </p>-->
<!--        <p slot="content" style="width: 300px" class="abstract">{{item.abs}}</p>-->
<!--        <el-row style="width: 135px;margin-bottom: 20px;height: 233px;float: left;margin-right: 15px" class="book"-->
<!--                bodyStyle="padding:10px" shadow="hover">-->
<!--          &lt;!&ndash;          <div class="cover" @click="editBook(item)">&ndash;&gt;-->
<!--          &lt;!&ndash;            <img :src="item.cover" alt="封面">&ndash;&gt;-->
<!--          &lt;!&ndash;          </div>&ndash;&gt;-->
<!--          &lt;!&ndash;          <div class="info">&ndash;&gt;-->
<!--          &lt;!&ndash;            <div class="title">&ndash;&gt;-->
<!--          &lt;!&ndash;              <a href="">{{item.title}}</a>&ndash;&gt;-->
<!--          &lt;!&ndash;            </div>&ndash;&gt;-->
<!--          &lt;!&ndash;            <i class="el-icon-delete" @click="deleteBook(item.id)"></i>&ndash;&gt;-->
<!--          &lt;!&ndash;          </div>&ndash;&gt;-->
<!--          &lt;!&ndash;          <div class="author">{{item.author}}</div>&ndash;&gt;-->
<!--          <edit-form @onSubmit="loadBooks()" ref="edit"></edit-form>-->
<!--        </el-row>-->
<!--      </el-tooltip>-->

    </el-row>
    <el-row>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pagesize"
        :total="books.length">
      </el-pagination>
    </el-row>
  </div>
</template>
<script>
  import SearchBar from './bar/SearchBar'

  export default {
    name: 'TaskList',
    components: {SearchBar},
    data() {
      return {
        books: [],
        currentPage: 1,
        pagesize: 17
      }
    },
    mounted: function () {
      this.loadBooks()
    },
    methods: {
      loadBooks() {
        var _this = this
        this.$axios.post('/list', {access_token: _this.$store.state.access_token}).then(resp => {
          console.log('list')
          console.log(resp)
          if (resp && resp.status === 200) {
            _this.books = resp.data.data
          }
        })
      },
      handleCurrentChange: function (currentPage) {
        this.currentPage = currentPage
        console.log(this.currentPage)
      },
      searchResult() {
        var _this = this
        this.$axios
          .get('/search?keywords=' + this.$refs.searchBar.keywords, {}).then(resp => {
          if (resp && resp.status === 200) {
            _this.books = resp.data.data
          }
        })
      },
      deleteBook(id) {
        this.$confirm('此操作将永久删除该书籍, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.$axios
              .post('/delete', {id: id}).then(resp => {
              if (resp && resp.status === 200) {
                this.loadBooks()
              }
            })
          }
        ).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
        // alert(id)
      },
      editBook(item) {
        this.$refs.edit.dialogFormVisible = true
        this.$refs.edit.form = {
          id: item.id,
          cover: item.cover,
          title: item.title,
          author: item.author,
          date: item.date,
          press: item.press,
          abs: item.abs,
          category: {
            id: item.category.id.toString(),
            name: item.category.name
          }
        }
      }
    }
  }
</script>
<style scoped>

  .cover {
    width: 115px;
    height: 172px;
    margin-bottom: 7px;
    overflow: hidden;
    cursor: pointer;
  }

  img {
    width: 115px;
    height: 172px;
    /*margin: 0 auto;*/
  }

  .title {
    font-size: 14px;
    text-align: left;
  }

  .author {
    color: #333;
    width: 102px;
    font-size: 13px;
    margin-bottom: 6px;
    text-align: left;
  }

  .abstract {
    display: block;
    line-height: 17px;
  }

  .el-icon-delete {
    cursor: pointer;
    float: right;
  }

  .switch {
    display: flex;
    position: absolute;
    left: 780px;
    top: 25px;
  }

  a {
    text-decoration: none;
  }

  a:link, a:visited, a:focus {
    color: #3377aa;
  }
</style>



// WEBPACK FOOTER //
// src/components/task/TaskList.vue